export const somethingWentWrong = 'Something went wrong';
